import React, { useEffect, useRef } from 'react';
import { SelectableButton } from '@moda/om';
import { useLocation, matchPath } from 'react-router-dom';
import { ACCOUNT_ROUTES, hrefFor } from '../../routers';

import './AccountNavMobile.scss';

export const AccountNavMobile: React.FC = () => {
  const { pathname } = useLocation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const button = document.getElementById(`AccountNavMobile--${pathname}`);

    if (!button) return;

    containerRef.current?.scrollTo({
      left: button.offsetLeft - (window.innerWidth - button.clientWidth) / 2,
      behavior: 'smooth'
    });
  }, [pathname]);

  return (
    <div className="AccountNavMobile" ref={containerRef}>
      {ACCOUNT_ROUTES.map(route => (
        <SelectableButton
          id={`AccountNavMobile--${hrefFor[route.key]()}`}
          key={route.key}
          selected={matchPath(pathname, route) != null}
          to={hrefFor[route.key]()}
        >
          {route.label}
        </SelectableButton>
      ))}
    </div>
  );
};
